<script>
import { orderReportMethods, customerMethods } from '../../state/helpers'
import constant from '@constants/constant.json'
export default {
  props: {
    selectstandardtime: {
      type: String,
      default: '',
    },
    fields: {
      type: Array,
      default: null,
    },
    showTimeZones: {
      type: String,
      default: 'Y',
    },
    showAdvanced: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      searchProducts: [],
      searchUsers: [],
      orderedForList: [],
      customers: [],
      selectusers: 'All',
      prependstart: 'Start Date',
      prependend: 'End Date',
      selectedDate: null,
      startdate: null,
      enddate: null,
      isAdvanceSearch: false,
      orderNo: '',
      firstName: '',
      lastName: '',
      customer: '',
      ssn: '',
      orderedBy: '',
      orderedFor: '',
      product: '',
      status: '',
      costToBorrower: false,
      costToBusiness: false,
      search: '',
      maxdate: '',
      optionsusers: [
        { value: 'All', text: 'All' },
        { value: 'IPAddress', text: 'Ip Address' },
        { value: 'LoanOfficerName', text: 'Loan Officer Name' },
        { value: 'ConsumerName', text: 'Consumer Name' },
        { value: 'EmailAddress', text: 'Consumer Email ID' },
        { value: 'MobileNumber', text: 'Consumer Mobile Number' },
        { value: 'ProductName', text: 'Product' },
        { value: 'ConsumerDecision', text: 'Consumer Decision' },
      ],
      optiontimezone: [
        { value: 'Eastern Standard Time', text: 'Eastern Standard Time(EST)' },
        { value: 'Central Standard Time', text: 'Central Standard Time(CST)' },
        {
          value: 'Mountain Standard Time',
          text: 'Mountain Standard Time(MST)',
        },
        { value: 'Pacific Standard Time', text: 'Pacific Standard Time(PST)' },
      ],
      showSpinner: false,
      savedSearchData: null,
      summaryStatus: false,
    }
  },
  computed: {
    supplementStatusList() {
      return this.$_supplementStatusList
    },
    showDateRange() {
      return this.selectusers !== 'orderNumber' && this.title === constant.usageReport
    },
  },
  mounted() {
    document.body.addEventListener('keyup', (e) => {
      if (e.keyCode === 27) {
        this.isDefault = true
        this.isOpen = false
      }
    })

    // To bind the User Options dropdown.
    this.prepareUserOptionsList()
    this.getMaxDateLimit()
    this.setStartDate()
    this.setEndDate()
    this.retainSearchCriteria()
  },
  methods: {
    ...orderReportMethods,
    ...customerMethods,
    retainSearchCriteria() {
      this.savedSearchData = this.$store.state.saveSearchModule.searchData || null
      this.summaryStatus = this.$store.state.saveSearchModule.summaryStatus
      if (this.savedSearchData !== null && this.summaryStatus) {
          this.search = this.savedSearchData ? this.savedSearchData.search : ''
          this.startdate = this.savedSearchData ? this.savedSearchData.startdate : ''
          this.enddate = this.savedSearchData ? this.savedSearchData.enddate : ''
          this.selectusers = this.savedSearchData ? this.savedSearchData.selectusers : 'orderNumber'
          this.isAdvanceSearch = this.savedSearchData.isAdvanceSearch
          if(this.isAdvanceSearch) {
            this.showAdvancedSearch('retainMode')
          }
        }
    },
    widthCompute(width) {
      return 8.33333 * width + '%'
    },
    getKey() {
      return Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, '')
        .substr(0, 7)
    },
    getCustomerData() {
      this.searchUsers = []
      this.orderedForList = []
      this.searchProducts = []

      this.getCustomerUsers()
      this.getCustomerProducts()
    },
    getCustomerProducts() {
      var customerId = this.customer ? this.customer.value : null
      if (!customerId) {
        return
      }

      this.showSpinner = true
      return this.fetchCustomerProducts({
        customerIds: [this.customer.value],
      })
        .then((response) => {
          if (response.data && Array.isArray(response.data)) {
            this.searchProducts = response.data.map((x) => {
              return {
                text: x.productName,
                value: x.productId,
              }
            })
          }
          this.showSpinner = false
        })
        .catch((error) => {
          this.showSpinner = false
          this.authError = error
        })
    },
    getCustomerUsers() {
      var customerId = this.customer ? this.customer.value : ''
      if (!customerId) return

      this.showSpinner = true
      this.searchUsers = []
      this.orderedForList = []
      this.orderedBy = ''
      this.orderedFor = ''

      return this.fetchCustomerUser({
        customerId: customerId,
        apiVersion: 2,
      })
        .then((response) => {
          if (response.data.orderedBy && response.data.orderedFor) {
            this.searchUsers = response.data.orderedBy.map((item) => {
              return {
                text: item.userFullName,
                value: item.userID,
              }
            })

            this.orderedForList = response.data.orderedFor.map((item) => {
              return {
                text: item.userFullName,
                value: item.userID,
              }
            })
          }
          // To retain saved data
          if (this.savedSearchData !== null && this.summaryStatus) {
            this.orderedBy = this.searchUsers.find((x) => x.text === this.savedSearchData.orderedBy)
            this.orderedFor = this.orderedForList.find((x) => x.text === this.savedSearchData.orderedFor)
            this.product = this.searchProducts.find((x) => x.text === this.savedSearchData.product)
            let statusCode = this.$_supplementStatusList.find((x) => x.text === this.savedSearchData.status) || null
            this.status = statusCode ? statusCode.value : ''
          }
          this.showSpinner = false
        })
        .catch((error) => {
          this.showSpinner = false
          this.authError = error
        })
    },
    getCustomers() {
      this.showSpinner = true
      this.product = ''
      return this.fetchCustomersByUserId()
        .then((response) => {
          this.customers = response.customers.map((x) => {
            return {
              text: x.name,
              value: x.customerId,
            }
          })
          // To retain saved data
          if (this.savedSearchData !== null && this.summaryStatus) {
            this.isAdvanceSearch = this.savedSearchData.isAdvanceSearch
            this.startdate = this.savedSearchData ? this.savedSearchData.startdate : ''
            this.enddate = this.savedSearchData ? this.savedSearchData.enddate : ''
            // this.orderNo = savedSearchData ? savedSearchData.orderNo : ''
            this.firstName = this.savedSearchData ? this.savedSearchData.firstName : ''
            this.lastName = this.savedSearchData ? this.savedSearchData.lastName : ''
            this.customer = this.customers.find((x) => x.text === this.savedSearchData.customer)
            this.ssn = this.savedSearchData ? this.savedSearchData.ssn : ''
            this.getCustomerProducts()
            this.getCustomerUsers()
          }
          this.showSpinner = false
        })
        .catch((error) => {
          this.showSpinner = false
          this.authError = error
        })
    },
    costOptionChanged(evt) {},
    resetAdvancedSearch() {
      this.orderNo = ''
      this.firstName = ''
      this.lastName = ''
      this.customer = ''
      this.ssn = ''
      this.orderedBy = ''
      this.orderedFor = ''
      this.product = ''
      this.status = ''
      this.costToBusiness = false
      this.costToBorrower = false
      this.searchProducts = []
      this.searchUsers = []
      this.orderedForList = []
      this.setStartDate()
      this.setEndDate()
    },
    showAdvancedSearch(toggleMode) {
      let toggleAdvanceSearch = this.savedSearchData ? this.savedSearchData.isAdvanceSearch : false
      if(!toggleAdvanceSearch || toggleMode === 'toggle'){
        this.isAdvanceSearch = !this.isAdvanceSearch
      }
      if (!this.isAdvanceSearch) {
        this.resetAdvancedSearch()
      }

      if (this.isAdvanceSearch) {
        if (!this.customers || this.customers.length === 0) {
          this.getCustomers()
        }
        if (
          !this.searchUsers ||
          this.searchUsers.length === 0 ||
          this.orderedForList.length === 0
        ) {
          this.getCustomerUsers()
        }
      }
      this.$emit('advanceSearchChanged', this.isAdvanceSearch)
    },
    onSearchSubmit(selectedValue) {
      if (selectedValue.isAdvanceSearch) {
        this.$validator.validateAll().then((res) => {
          if (res) {
            this.$emit('searchSubmit', selectedValue)
          }
        })
        return
      }
      this.$emit('searchSubmit', selectedValue)
    },
    setStartDate() {
      let today = new Date()
      let month =
        today.getMonth() + 1 <= 9
          ? '0' + (today.getMonth() + 1)
          : today.getMonth() + 1

      this.startdate = `${month}/${today.getDate()}/${today.getFullYear()}`
    },
    setEndDate() {
      let today = new Date()
      let month =
        today.getMonth() + 1 <= 9
          ? '0' + (today.getMonth() + 1)
          : today.getMonth() + 1

      this.enddate = `${month}/${today.getDate()}/${today.getFullYear()}`
    },

    getMaxDateLimit() {
      let today = new Date()
      let month =
        today.getMonth() + 1 <= 9
          ? '0' + (today.getMonth() + 1)
          : today.getMonth() + 1

      this.maxdate = `${month}/${today.getDate()}/${today.getFullYear()}`
    },
    // Preparing the User Options list based on the 'fields' property which is used for Grid header.
    prepareUserOptionsList() {
      if (this.fields !== undefined && this.fields != null) {
        this.optionsusers = []

        this.fields.forEach((item, index) => {
          if (item.sortable)
            this.optionsusers.push({ value: item.key, text: item.label })
        })

        if (this.title === constant.usageReport) {
          this.selectusers = 'orderNumber'
          this.optionsusers.push({
            value: 'salesExecutive',
            text: 'Sales Executive',
          })
          this.optionsusers.shift()
        }

        // Adding 'All' option to display as first option.
        if(this.title !== constant.usageReport) {
          this.optionsusers.unshift({ value: 'All', text: 'All' })
        }
      }
    },
  },
}
</script>

<template>
  <b-form
    class="mt-2 mb-0 pb-0 ml-1"
    novalidate
    @submit.prevent="
      onSearchSubmit({
        startdate,
        enddate,
        selectstandardtime,
        selectusers,
        search,
        orderNo,
        firstName,
        lastName,
        //orderedBy: orderedBy ? orderedBy.value : null,
        //orderedFor: orderedFor ? orderedFor.value : null,
        //product: product ? product.value : null,
        orderedBy: orderedBy ? orderedBy.text : null,
        orderedFor: orderedFor ? orderedFor.text : null,
        product: product ? product.text : null,
        status: status
          ? supplementStatusList.filter((x) => x.value === parseInt(status))[0]
              .text
          : null,
        customer: customer ? customer.text : null,
        costToBorrower,
        costToBusiness,
        ssn: ssn ? ssn.replace(/-/g, '') : null,
        isAdvanceSearch,
      })
    "
  >
  <BaseSpinner v-show="showSpinner" />
    <b-row v-if="!isAdvanceSearch" class="minimized mr-0 pr-0">
      <div v-if="showDateRange" class="d-inline mr-1" :style="{ width: widthCompute(1.5) }">
        <BaseDate
          v-model="startdate"
          v-validate="'required'"
          type="date"
          :field-id="getKey()"
          name="startdate"
          :max="maxdate"
          :prepend="prependstart"
          :class="{
            input: true,
            'is-danger': errors.has('startdate'),
          }"
        ></BaseDate>
        <div v-show="errors.has('startdate')" class="error"
          >Invalid Start Date</div
        >
      </div>
      <div v-else :style="{ width: widthCompute(1.5) }"></div>
      <div v-if="showDateRange" class="d-inline mr-1" :style="{ width: widthCompute(1.5) }">
        <BaseDate
          v-model="enddate"
          v-validate="'required'"
          type="date"
          :field-id="getKey()"
          name="enddate"
          :min="startdate"
          :max="maxdate"
          :prepend="prependend"
          :class="{
            input: true,
            'is-danger': errors.has('enddate'),
          }"
        ></BaseDate>
        <div v-show="errors.has('enddate')" class="error">Invalid End Date</div>
      </div>
      <div v-else :style="{ width: widthCompute(1.5) }"></div>
      <div
        v-if="showTimeZones === 'Y'"
        class="d-inline center--content mr-1"
        :style="{ width: widthCompute(1.5) }"
      >
        <b-form-select
          slot="prepend"
          v-model="selectstandardtime"
          :options="optiontimezone"
        ></b-form-select>
      </div>
      <div
        class="d-inline center--content mr-1"
        :style="{ width: widthCompute(1.5) }"
      >
        <b-form-select
          slot="prepend"
          v-model="selectusers"
          :options="optionsusers"
        />
      </div>
      <div class="d-inline mx-0 px-0 mr-1">
        <b-form-input
          v-model="search"
          class="rounded-1 w-100"
          placeholder="Type to Search"
          :style="{ width: widthCompute(4) }"
        ></b-form-input>
      </div>
      <div class="d-inline" :style="{ width: widthCompute(2.8) }">
        <BaseEButton slot="append" pre-icon="search" type="submit"
          >Search</BaseEButton
        >

        <BaseEButton
          v-if="showAdvanced"
          slot="append"
          variant="icon"
          @click="showAdvancedSearch('toggle')"
        >
          Advanced Search
        </BaseEButton>
      </div>
    </b-row>

    <b-row v-if="isAdvanceSearch" class="minimized search--wrap">
      <div class="d-inline mr-1" :style="{ width: widthCompute(1.5) }">
        <BaseELabel
          class="advancedSearchStyle"
          mark-required
          label="Request Date From"
        />
        <BaseDate
          v-model="startdate"
          v-validate="'required'"
          type="date"
          :field-id="getKey()"
          name="startdate"
          :max="maxdate"
          :prepend="prependstart"
          :class="{
            input: true,
            'is-danger': errors.has('startdate'),
          }"
        ></BaseDate>
        <div v-show="errors.has('startdate')" class="error"
          >Invalid Start Date</div
        >
      </div>
      <div class="d-inline mr-1" :style="{ width: widthCompute(1.5) }">
        <BaseELabel
          class="advancedSearchStyle"
          mark-required
          label="Request Date To"
        />
        <BaseDate
          v-model="enddate"
          v-validate="'required'"
          type="date"
          :field-id="getKey()"
          name="enddate"
          :min="startdate"
          :max="maxdate"
          :prepend="prependend"
          :class="{
            input: true,
            'is-danger': errors.has('enddate'),
          }"
        ></BaseDate>
        <div v-show="errors.has('enddate')" class="error">Invalid End Date</div>
      </div>
      <!-- <div class="d-inline mr-1" :style="{ width: widthCompute(1.2) }">
        <BaseELabel class="advancedSearchStyle" label="Order #" />
        <b-form-input
          v-model="orderNo"
          name="orderNo"
          :class="{
            input: true,
          }"
          placeholder="Order #"
        ></b-form-input>
      </div> -->
      <div class="d-inline mr-1" :style="{ width: widthCompute(1.2) }">
        <BaseELabel
          class="advancedSearchStyle"
          :mark-required="costToBorrower || costToBusiness"
          label="First Name"
        />
        <BaseEInputText
          :id="getKey()"
          v-model="firstName"
          v-validate="costToBorrower | costToBusiness ? 'required' : ''"
          name="firstName"
          :class="{
            input: true,
            'is-danger': errors.has('firstName'),
          }"
          placeholder="First Name"
        ></BaseEInputText>
        <div v-show="errors.has('firstName')" class="error">
          First Name Required
        </div>
      </div>

      <div class="d-inline mr-1" :style="{ width: widthCompute(1.2) }">
        <BaseELabel
          class="advancedSearchStyle"
          :mark-required="costToBorrower"
          label="Last Name"
        />
        <BaseEInputText
          :id="getKey()"
          v-model="lastName"
          v-validate="costToBorrower ? 'required' : ''"
          name="lastName"
          :class="{
            input: true,
            'is-danger': errors.has('lastName'),
          }"
          placeholder="Last Name"
        ></BaseEInputText>
        <div v-show="errors.has('lastName')" class="error">
          Last Name Required
        </div>
      </div>
      <div class="d-inline mr-1" :style="{ width: widthCompute(2) }">
        <BaseELabel class="advancedSearchStyle" label="Customer" />
        <BaseMultiSelect
          v-model="customer"
          type="text"
          :options="customers"
          :multiple="false"
          name="customer"
          mark-required
          placeholder="Select"
          data-vv-as="Customer[s]"
          label="text"
          track-by="value"
          :close-on-select="true"
          :clear-on-select="false"
          :class="$style.dropOptionstyle"
          @close="getCustomerData"
        />
      </div>
      <div class="d-inline mr-1" :style="{ width: widthCompute(1.2) }">
        <BaseELabel
          class="advancedSearchStyle"
          :mark-required="costToBorrower"
          label="SSN"
        />
        <BaseEInputText
          v-model="ssn"
          v-validate="{
            required: costToBorrower ? true : false,
            regex: /^\d{3}-?\d{2}-?\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{2})(\d{4})"
          formatter="$1-$2-$3"
          maxlength="11"
          type="text"
          name="ssn"
          :class="{
            input: true,
            'is-danger': errors.has('ssn'),
          }"
          placeholder="SSN"
        ></BaseEInputText>
        <div v-show="errors.has('ssn')" class="error">
          SSN Invalid
        </div>
      </div>
      <div class="d-inline mr-1" :style="{ width: widthCompute(1.2) }"> </div>
      <div class="d-inline mr-1" :style="{ width: widthCompute(1.2) }"> </div>
    </b-row>

    <b-row
      v-show="isAdvanceSearch"
      align-v="center"
      class="minimized search--wrap mt-2"
    >
      <div class="d-inline mr-1" :style="{ width: widthCompute(1.5) }">
        <BaseELabel class="advancedSearchStyle" label="Operator" />
        <BaseMultiSelect
          v-model="orderedBy"
          type="text"
          :options="searchUsers"
          :multiple="false"
          name="orderedBy"
          mark-required
          placeholder="Select"
          data-vv-as="orderedBy"
          label="text"
          track-by="value"
          :close-on-select="true"
          :clear-on-select="false"
          :class="$style.dropOptionstyle"
        />
      </div>
      <div class="d-inline mr-1" :style="{ width: widthCompute(1.5) }">
        <BaseELabel class="advancedSearchStyle" label="Ordered For" />
        <BaseMultiSelect
          v-model="orderedFor"
          type="text"
          :options="orderedForList"
          :multiple="false"
          name="orderedFor"
          mark-required
          placeholder="Select"
          data-vv-as="orderedFor"
          label="text"
          track-by="value"
          :close-on-select="true"
          :clear-on-select="false"
          :class="$style.dropOptionstyle"
        />
      </div>

      <div class="d-inline mr-1" :style="{ width: widthCompute(1.98) }">
        <BaseELabel class="advancedSearchStyle" label="Product" />
        <BaseMultiSelect
          v-model="product"
          type="text"
          :options="searchProducts"
          :multiple="false"
          name="product"
          mark-required
          placeholder="Select"
          data-vv-as="product[s]"
          label="text"
          track-by="value"
          :close-on-select="true"
          :clear-on-select="false"
          :class="$style.dropOptionstyle"
        />
      </div>
      <div class="d-inline mr-1" :style="{ width: widthCompute(1.65) }">
        <BaseELabel class="advancedSearchStyle" label="Status" />
        <BaseDropdown
          v-model="status"
          :field-id="status"
          :options="supplementStatusList"
          name="status"
          placeholder="Select"
        ></BaseDropdown>
      </div>

      <div class="d-inline mr-1 ml-3 mt-4">
        <!-- Hidden temporarily until further requirement update -->
        <!-- <b-row align-v="center" class="mx-0 px-0 mb-1">
          <b-form-checkbox
            v-model="costToBorrower"
            type="checkbox"
            name="costToBorrower"
            class="mr-2 d-inline"
            @change="costOptionChanged"
          />
          <BaseELabel
            class="d-inline advancedSearchStyle"
            label="Cost To Borrower"
          />
        </b-row> -->
        <div>
          <div class="d-inline mr-1" :style="{ width: widthCompute(1.2) }">
            <BaseEButton slot="append" pre-icon="search" type="submit"
              >Search</BaseEButton
            >
          </div>
          <div class="d-inline mr-1" :style="{ width: widthCompute(1.3) }">
            <BaseEButton
              slot="append"
              variant="icon"
              pre-icon="sync"
              @click="resetAdvancedSearch"
              >Reset</BaseEButton
            >
          </div>
          <div class="d-inline mr-1" :style="{ width: widthCompute(1.3) }">
            <BaseEButton
              slot="append"
              variant="icon"
              pre-icon="times-circle"
              @click="showAdvancedSearch('toggle')"
            >
              Close
            </BaseEButton>
          </div>
        </div>
        <!-- <b-row class="mb-2 m-0 p-0" style="margin-top:-2px"> -->
        <!-- <b-col md="auto" class="px-1">
          <input
              v-model="costToBusiness"
              type="checkbox"
              name="costToBusiness"
              value="true"
              unchecked-value="false"
              class="mr-2"
              @change="costOptionChanged">
          <label class="form-check-label advancedSearchStyle normalize">
            Cost To Business
          </label>
        </b-col> -->
        <!-- </b-row> -->
      </div>

      <!-- <div class="d-inline mr-1" :style="{ width: widthCompute(1.5) }"> -->
      <!-- <a
          href="#"
          class="btn btn-link text-white-50 bg-transparent border-0 btn-secondary ml-1"
          @click="$emit('closeButton')"
        >
          <BaseIcon name="times" />
        </a> -->
      <!-- </div> -->
    </b-row>
  </b-form>
</template>

<style lang="scss" scoped>
/* stylelint-disable selector-pseudo-element-no-unknown, selector-class-pattern */
::v-deep .search--wrap .form-control {
  height: 41px !important;
}

.center--content {
  text-align: center;
}
::v-deep .minimized * {
  font-size: 0.85rem;
}
.advancedSearchStyle {
  font-size: 0.7rem;
  color: #b1aeae;
}
.advancedSearchStyle.normalize {
  font-size: 1rem;
  color: #dfdbdb;
}
</style>
<style lang="scss" module>
@import '@design';

.searchReport {
  padding: 5px;

  /* background-color: #2e4253; */
  opacity: 1;
}
.searchAllignment {
  width: 170px;
}
</style>
